import { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

interface Props {
    children: ReactNode;
    className?: string;
}

const CardCallDetailsContainer = ({ children, className }: Props) => (
    <div className={twMerge('bg-gray-150 flex rounded p-3', className)}>
        {children}
    </div>
);

export default CardCallDetailsContainer;
